import type { Instrument } from "@/types/api";
import PlayButton from "./play-button";

const AUDIO_PREVIEW_KEY = "inst_audio_preview";

export const InstrumentRow: React.FC<React.HTMLAttributes<HTMLDivElement> & Instrument> = ({
  instrumentName,
  instrumentModifier,
  instrumentArticulation,
  instrumentArticulationModifier,
  assets
}) => {

  //filter out any empty strings, then concat with spaces
  const nameModifiers = [instrumentModifier, instrumentArticulation, instrumentArticulationModifier].filter(str => str).join(' ');

  return (
    <div
      className="w-full p-2 px-4 flex flex-row justify-between"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
    >
      <div className="flex flex-row items-center gap-2 text-musio-gray text-sm">
        <p><span className="text-musio-light-lilac">{instrumentName}</span>{nameModifiers ? ` | ${nameModifiers}` : ""}</p>
      </div>
      {/* TODO: disabled for soft-launch  */}
      {assets[AUDIO_PREVIEW_KEY]?.url ? (
        <PlayButton audioUrl={assets[AUDIO_PREVIEW_KEY].url} />
      ) : null}
    </div>
  )
};
